import { Dtos, SuretyAccountId, WorkInProgressStatementId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { wipQueryKey } from "../../account/account.keys";

export const useAdminUpsertWorkInProgressStatement = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post, put } = useRequest();

	const mutation = useMutation({
		mutationKey: ["upsertWipStatement"],
		mutationFn: async ({
			data,
			workInProgressId,
		}: {
			data: Dtos.Admin.WipStatement.Create.Request | Dtos.Admin.WipStatement.Update.Request;
			workInProgressId?: WorkInProgressStatementId;
		}) => {
			if (workInProgressId) {
				return await put(`/v2/admin/surety/wip-statement/${workInProgressId}`, data, "none");
			}
			return await post(`/v2/admin/surety/wip-statement`, data, "none");
		},
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: wipQueryKey(accountId),
			});
			await queryClient.refetchQueries({
				queryKey: wipQueryKey(accountId),
			});
		},
	});

	return {
		upsertWipStatement: mutation.mutate,
		upsertWipStatementIsLoading: mutation.isPending,
		upsertWipStatementSuccess: mutation.isSuccess,
	};
};
